import axios from "axios";
axios.defaults.preflightContinue = true;
axios.defaults.crossDomain = true;
//axios.defaults.withCredentials = !!token;
axios.defaults.headers.common = {
  ...axios.defaults.headers.common,
  //"Access-Control-Allow-Origin": "//withtomatoseven.kr",
  //"Content-Type": "application/json;charset=UTF-8",
  //"Access-Control-Allow-Origin": "*",
  //"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  //Accept: "application/json",
  //Authorization: "zaka",
};

const board_calendar = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/board_calendar.php",
    JSON.stringify(payload)
  );
};

const board_a = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/board_a.php",
    JSON.stringify(payload)
  );
};

const board_files = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/board_files.php",
    payload.form,
    payload.config
  );
};
const board_files_down = (payload) => {
  console.log("board_files_down", payload);
  return axios.post(
    "//withtomatoseven.kr/friends/board_filesDown.php",
    payload.form,
    payload.config
  );
};
const kakao_auth = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/kakao_rest_api.php",
    JSON.stringify(payload)
  );
};
const employee_info = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/employee_info.php",
    JSON.stringify(payload)
  );
};
const client_info = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/client_info.php",
    JSON.stringify(payload)
  );
};
const branch_info = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/branch_info.php",
    JSON.stringify(payload)
  );
};
//
//
export default {
  async board_calendar(payload) {
    try {
      const Response = await board_calendar(payload);
      //      console.log("board_calendar", Response);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async board_a(payload) {
    try {
      const Response = await board_a(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async board_files(payload) {
    try {
      const Response = await board_files(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async board_files_down(payload) {
    try {
      const Response = await board_files_down(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async kakao_auth(payload) {
    try {
      const Response = await kakao_auth(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async employee_info(payload) {
    try {
      const Response = await employee_info(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async client_info(payload) {
    try {
      const Response = await client_info(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async branch_info(payload) {
    try {
      const Response = await branch_info(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
};
